<template>
  <div>
    <v-row>
      <v-col
        cols="4"
        v-for="moduleItem in modulesList" :key="moduleItem.id"
        align-self="center"
      >
        <v-card
          min-height="90px"
          @click="selectModule(moduleItem)"
          :style="moduleItem.clicked ? 'border: 4px solid #005b53; padding: 10px;' : 'padding: 10px;'"
        >
          <v-row justify="center">
            <v-col cols="3" align-self="center">
              <component
                :is="moduleItem.icon"
                height="40px"
                width="40px"
              />
            </v-col>
            
            <v-col cols="9" align-self="center">
              <!-- module name -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <h4 class="text-left card-text">
                      {{ moduleItem.name }}
                    </h4>
                  </div>
                </template>
                <span>{{ moduleItem.name }}</span>
              </v-tooltip>

              <!-- module description -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <h4 class="font-weight-medium text-left card-text">
                      {{ moduleItem.description }}
                    </h4>
                  </div>
                </template>
                <span>{{ moduleItem.description }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import api from "@api/index"
import { mapActions, mapGetters } from "vuex"
// import endpoints from "@api/repository"
// import Helper from "@utils/misc"

export default {
  name: 'SelectModules',

  components: {
    StudentsIcon: () => import("@components/icons/StudentIcon"),
    StaffIcon: () => import("@components/icons/StaffIcon"),
    ClassroomsIcon: () => import("@components/icons/ClassroomsIcon"),
    FeesIcon: () => import("@components/icons/FeesIcon"),
    AdmissionsIcon: () => import("@components/icons/AdmissionIcon"),
    InventoryIcon: () => import("@components/icons/InventoryIcon"),
    StudentsAttendanceIcon: () => import("@components/icons/StudentAttendanceIcon"),
    StaffAttendanceIcon: () => import("@components/icons/StaffAttendanceIcon"),
    FinanceIcon : () => import("@components/icons/FinanceIcon"),
    PayrollIcon : () => import("@components/icons/PayRollIcon"),
    AcademicsIcon:() => import("@components/icons/AcademicsIcon"),
    TaskIcon:() => import("@components/icons/TaskIcon"),
  },

  props: {},

  data() {
    return {
      modulesList: [
        {
          id: 1,
          name: 'Students',
          icon: 'StudentsIcon',
          description: 'Manage students in a few clicks',
          clicked: false
        },
        {
          id: 2,
          name: 'Staff',
          icon: 'StaffIcon',
          description: 'Manage staff in a few clicks',
          clicked: false
        },
        {
          id: 3,
          name: 'Classrooms',
          icon: 'ClassroomsIcon',
          description: 'Manage classrooms and subjects',
          clicked: false
        },
        {
          id: 4,
          name: 'Fees',
          icon: 'FeesIcon',
          description: 'Manage fees in a few clicks',
          clicked: false
        },
        {
          id: 5,
          name: 'Admissions',
          icon: 'AdmissionsIcon',
          description: 'Manage admissions in a few clicks',
          clicked: false
        },
        {
          id: 6,
          name: 'Inventory',
          icon: 'InventoryIcon',
          description: 'Manage the institutional inventory in a few clicks',
          clicked: false
        },
        {
          id: 7,
          name: 'Student Attendance',
          icon: 'StudentsAttendanceIcon',
          description: 'Manage Student Attendance in a few clicks',
          clicked: false
        },
        {
          id: 8,
          name: 'Staff Attendance',
          icon: 'StaffAttendanceIcon',
          description: 'Manage Staff Attendance in a few clicks',
          clicked: false
        },
        {
          id: 9,
          name: 'Payroll',
          icon: 'PayrollIcon',
          description: 'Handle payrolls and payslips of the staff',
          clicked: false
        },
        {
          id: 10,
          name: 'Finances',
          icon: 'FinanceIcon',
          description: 'Handle Finances in an efficient manner',
          clicked: false
        },
        {
          id: 11,
          name: 'Academics',
          icon: 'AcademicsIcon',
          description: 'Manage academics',
          clicked: false
        },
        {
          id: 12,
          name: 'Tasks',
          icon: 'TaskIcon',
          description: 'Manage tasks assigned to & by people',
          clicked: false
        },
      ],

      selectedModules: [0,1,2,3]
    }
  },

  computed: {
    ...mapGetters([
			"currentUser",
			"accessToken",
			"isLoading",
			"currentInstitution",
		]),

		apiEssentials() {
			return {
				accessToken: this.accessToken,
				setLoading: this.setLoading,
				handleErrorsFunction: this.handleApiErrors,
			};
		},
  },

  methods: {
    ...mapActions(["setLoading"]),

    async handleApiErrors(err) {
      this.setLoading(false);
      console.log(err);
      if (err.response) {
        if (err.response.status == 409) {
          this.snackbar.message = err.response.data;
          this.snackbar.color = "error";
          this.snackbar.visible = true;
        }
      } else {
        this.snackbar.message = "Unable to process request";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      }
    },

    // map available features for the institution if already selected (before)
    mapModulesForInstitution() {
      if(this.selectedModules && this.selectedModules.length) {
        this.modulesList.forEach(item => {
          if(this.selectedModules.includes(item.id)) {
            item.clicked = true
          }
        })
      }
    },

    selectModule(item) {
      // allow no manipulations on required modules
      if(item.id == 1 || item.id == 2 || item.id == 3) {
        return
      }

      item.clicked = !item.clicked

      // when a module is selected
      if(item.clicked) {
        if(!this.selectedModules.includes(item.id)) {
          this.selectedModules.push(item.id)
        }
      }
      // when a module is unselected
      else {
        if(this.selectedModules.includes(item.id)) {
          let index = this.selectedModules.findIndex(mod => mod == item.id)

          if(index != -1) {
            this.selectedModules.splice(index, 1)
          }
        }
      }

      this.selectedModules.sort((a, b) => (a-b))

      this.$emit('updateSelectedModules', this.selectedModules)
    },
  },

  mounted() {
    this.$nextTick(() => {
      let features = JSON.parse(this.currentInstitution.erp_features)

      // if feeatures already available from backend apart (not the default one), show them as selected
      if(features.length > 1) {
        this.selectedModules = features
      }

      this.mapModulesForInstitution()
      this.$emit('updateSelectedModules', this.selectedModules)
    })
  },

  created() {}
}
</script>

<style scoped>
  .card-text {
    line-height: 1.2em; 
    /* max-height: 3em; */
    /* -webkit-line-clamp: 2;
    -webkit-box-orient: vertical; */
    
    display: inline-block;
    white-space: nowrap;
    overflow: hidden; 
    text-overflow: ellipsis; 
    width: 100%;
  }
</style>